/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Period_Preset_YearInputs */

const cs_dashboard_period_preset_year = /** @type {(inputs: Dashboard_Period_Preset_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tento rok`)
};

const en_dashboard_period_preset_year = /** @type {(inputs: Dashboard_Period_Preset_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This year`)
};

/**
* | output |
* | --- |
* | "This year" |
*
* @param {Dashboard_Period_Preset_YearInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const dashboard_period_preset_year = /** @type {((inputs?: Dashboard_Period_Preset_YearInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Period_Preset_YearInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dashboard_period_preset_year(inputs)
	return cs_dashboard_period_preset_year(inputs)
});